// Generated from src/assets/BorderedClose.svg
import React, { PureComponent } from "react";

interface ISVGDICOMDeleteIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  cursor: "pointer"
};

export default class SVGDICOMDeleteIcon extends PureComponent<
  ISVGDICOMDeleteIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        width="25px"
        height="30px"
        viewBox="0 0 25 25"
        enableBackground="new 0 0 25 25"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M24.087,9.96c-0.611-0.318-1.538-0.098-2.102-0.443
	c-0.488-0.283-0.474-1.174-0.886-1.549c0.279-0.767,1.086-1.245,1.328-1.992c0.484-1.492-1.973-2.985-2.655-3.542
	c-1.201,0.006-2.138,0.638-2.656,1.329c-0.591-0.259-1.18-0.517-1.771-0.776c-0.369-0.518-0.183-1.592-0.553-2.102
	C14.658,0.496,14.273,0.125,13.906,0c-1.033,0-2.066,0-3.099,0c-0.322,0.103-0.616,0.477-0.886,0.664
	c-0.17,0.75-0.4,1.584-0.442,2.435C8.752,3.218,8.36,3.598,7.708,3.763C7.154,3.185,6.356,2.936,5.716,2.435
	C4.478,2.474,2.796,4.04,2.507,4.98C1.88,5.936,3.181,7.36,3.613,7.747C3.56,8.358,3.27,9.112,2.949,9.517
	C2.406,9.886,1.514,9.688,0.847,9.96c-1.156,0.471-0.903,2.467-0.885,4.095c0.283,0.287,0.649,0.683,0.885,0.996
	c0.738,0.111,1.477,0.222,2.214,0.332c0.081,0.567,0.334,1.207,0.664,1.549c-0.105,0.521-0.987,1.794-1.328,2.214
	c0.035,1.103,1.745,2.939,2.545,3.209c1.068,0.684,2.278-0.783,2.877-1.107c0.148-0.088,1.383,0.435,1.66,0.665
	c0.69,1.114-0.053,2.423,1.328,2.877c0,0.036,0,0.073,0,0.11c3.162,0.096,4.439,0.178,4.427-2.988
	c0.544-0.225,1.255-0.398,1.66-0.775c0.667,0.233,1.549,0.881,2.103,1.328c1.818-0.012,2.52-1.691,3.431-2.656
	c-0.004-1.191-0.621-2.169-1.328-2.656c0.144-0.537,0.446-1.354,0.775-1.771c0.572-0.374,1.587-0.112,2.213-0.442
	c0.331-0.174,0.477-0.658,0.775-0.885C24.896,12.483,25.114,10.496,24.087,9.96z M23.423,13.612
	c-0.466,0.318-1.395,0.142-1.881,0.443c-1.313,0.067-1.198,1.933-1.882,2.656c0.041,1.405,0.985,1.607,1.329,2.656
	c0.174,0.101-1.245,1.471-1.549,1.66c-0.245,0.163-1.747-0.995-1.992-1.327c-1.102,0.031-2.663,0.854-3.431,1.327
	c-0.111,0.812-0.222,1.624-0.333,2.435c-0.037,0-0.074,0-0.11,0c0,0.037,0,0.075,0,0.111c-0.639,0.015-1.899,0.166-2.324-0.111
	c-0.318-0.466-0.142-1.395-0.442-1.881c-0.075-1.398-1.963-1.082-2.656-1.881c-1.293,0.059-1.542,1-2.545,1.327
	c-0.469,0.153-1.309-1.115-1.771-1.438c0.143-0.761,0.94-1.733,1.438-2.213c-0.095-0.898-0.848-2.262-1.217-3.099
	c-0.631-0.251-1.843-0.181-2.435-0.553c-0.075,0-0.148,0-0.222,0c0-0.812,0-1.623,0-2.435c0.713-0.141,2.018-0.157,2.545-0.553
	c0.646-0.556,0.623-1.929,1.217-2.545c-0.029-0.984-0.841-2.09-1.438-2.545c0.274-0.764,1.12-1.13,1.549-1.771
	C6.28,4.078,6.61,5.014,7.598,5.201c0.257,0.114,2.643-0.954,3.099-1.217c0.174-0.851,0.27-1.908,0.553-2.656
	c0.738,0,1.476,0,2.213,0c0.097,0.13,0.089,0.125,0.221,0.221c0.011,0.732,0.091,1.868,0.443,2.324
	c0.274,0.625,2.021,0.713,2.545,1.328c1.382-0.034,1.818-0.95,2.767-1.438c0.392,0.581,1.493,1.261,1.549,1.771
	c-0.199,0.615-0.846,1.514-1.329,1.881c0.032,1.102,0.855,2.662,1.329,3.431c0.812,0.11,1.623,0.221,2.435,0.333
	c0,0.036,0,0.073,0,0.11c0.037,0,0.074,0,0.11,0C23.548,11.927,23.699,13.187,23.423,13.612z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#FFFFFF"
          d="M11.692,7.082c-0.425,0.273-1.069,0.235-1.549,0.443
	C8.999,8.021,7.86,9.247,7.376,10.402c-1.5,3.589,1.859,8.308,5.755,7.415c1.915-0.438,3.491-1.475,4.205-3.098
	C19.188,10.51,15.855,7.004,11.692,7.082z M13.352,16.379c-2.776,0.772-5.601-2.108-4.869-4.87c0.269-1.016,1.079-2.048,1.881-2.545
	c0.34-0.211,0.799-0.217,1.107-0.443c2.485-0.06,3.939,0.674,4.647,2.324C17.28,13.548,15.207,15.863,13.352,16.379z"
        />
      </svg>
    );
  }
}
